var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeapDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_14675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51657 12.2248C1.57778 13.0413 2.19844 13.7172 3.00549 13.8559C3.84501 14.0002 4.71145 14.1387 5.59737 14.1387C6.48332 14.1387 7.34975 14.0002 8.18927 13.8559C8.99632 13.7172 9.61698 13.0413 9.67818 12.2248C9.78702 10.7728 9.90863 9.26256 9.90863 7.71218C9.90863 6.16179 9.78702 4.65159 9.67818 3.19959C9.61698 2.38301 8.99632 1.70714 8.18927 1.56845C7.34975 1.42418 6.48332 1.28564 5.59737 1.28564C4.71145 1.28564 3.84501 1.42418 3.00549 1.56845C2.19844 1.70714 1.57778 2.38301 1.51657 3.19959C1.40773 4.65159 1.28613 6.16179 1.28613 7.71218C1.28613 9.26256 1.40774 10.7728 1.51657 12.2248Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3222 20.8004C14.3834 21.6171 15.0041 22.2928 15.8112 22.4315C16.6507 22.5759 17.5171 22.7144 18.403 22.7144C19.289 22.7144 20.1554 22.5759 20.9949 22.4315C21.802 22.2928 22.4227 21.6171 22.4839 20.8004C22.5927 19.3484 22.7143 17.8383 22.7143 16.2879C22.7143 14.7375 22.5927 13.2273 22.4839 11.7753C22.4227 10.9587 21.802 10.2828 20.9949 10.1441C20.1554 9.99986 19.289 9.86133 18.403 9.86133C17.5171 9.86133 16.6507 9.99986 15.8112 10.1441C15.0041 10.2828 14.3834 10.9587 14.3222 11.7753C14.2134 13.2273 14.0918 14.7375 14.0918 16.2879C14.0918 17.8383 14.2134 19.3484 14.3222 20.8004Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1557 4.30906C14.2794 5.10332 14.9915 5.68908 15.7939 5.73797C16.6388 5.78945 17.5111 5.83922 18.403 5.83922C19.295 5.83922 20.1674 5.78947 21.0122 5.73797C21.8146 5.68908 22.5268 5.10332 22.6505 4.30906C22.6888 4.06359 22.7143 3.81451 22.7143 3.56242C22.7143 3.31035 22.6888 3.06127 22.6505 2.8158C22.5268 2.02154 21.8146 1.43579 21.0122 1.38689C20.1674 1.3354 19.295 1.28564 18.403 1.28564C17.5111 1.28564 16.6388 1.3354 15.7939 1.38689C14.9915 1.43579 14.2794 2.02154 14.1557 2.8158C14.1174 3.06127 14.0918 3.31035 14.0918 3.56242C14.0918 3.81451 14.1174 4.06359 14.1557 4.30906Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34998 21.184C1.4737 21.9782 2.18584 22.564 2.9882 22.6128C3.83312 22.6644 4.70536 22.7141 5.59737 22.7141C6.48938 22.7141 7.36165 22.6644 8.20655 22.6128C9.0089 22.564 9.72105 21.9782 9.84477 21.184C9.883 20.9385 9.90863 20.6894 9.90863 20.4374C9.90863 20.1852 9.883 19.9361 9.84477 19.6906C9.72105 18.8964 9.0089 18.3106 8.20655 18.2618C7.36165 18.2104 6.48938 18.1606 5.59737 18.1606C4.70536 18.1606 3.83312 18.2104 2.9882 18.2618C2.18584 18.3106 1.4737 18.8964 1.34998 19.6906C1.31175 19.9361 1.28613 20.1852 1.28613 20.4374C1.28613 20.6894 1.31175 20.9385 1.34998 21.184Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_14675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeapDashboardIcon);
export default __webpack_public_path__ + "static/media/peap-dashboard-icon.0b567b8c4af2ccbb81a89e43b7d234d5.svg";
export { ForwardRef as ReactComponent };